<div class="app-label-color">
  <div class="palette-container" [style.background-color]="(color != null) ? (color.indexOf('#')) > -1 ? color : '#' + color : ''">
    &nbsp;
  </div>
</div>

